import { render, staticRenderFns } from "./InstantChatIntro.vue?vue&type=template&id=02f5db2d&"
import script from "./InstantChatIntro.vue?vue&type=script&lang=js&"
export * from "./InstantChatIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports